export const KBB_BRAND = 'kbb';
export const FORD_BRAND = 'ford';
export const ATC_BRAND = 'atc';
export const DEMO_BRAND = 'demo';
export const PREVIEW_BRAND = 'previewAtc';
export const CAR_AND_DRIVER = 'carAndDriver';